var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EqModelLoader } from '../main/model_loader';
var EqServerModelLoader = /** @class */ (function (_super) {
    __extends(EqServerModelLoader, _super);
    function EqServerModelLoader(context) {
        return _super.call(this, context) || this;
    }
    EqServerModelLoader.prototype.init = function () {
    };
    EqServerModelLoader.prototype.sendLoadModelRequest = function (options) {
        var _this = this;
        var context = this.getContext();
        var http = context.getServices().getHttpClient();
        var url = context.resolveEndpoint('GetModel', { modelId: options.modelId });
        http.get(url)
            .then(function (responseData) {
            if (!responseData.model) {
                _this.modelLoadingRejectFunc(new Error('Wrong response format for "GetModel" request'));
            }
            _this.modelLoadingResolveFunc(responseData.model);
        })
            .catch(function (error) {
            _this.modelLoadingRejectFunc(error);
        });
    };
    return EqServerModelLoader;
}(EqModelLoader));
export { EqServerModelLoader };
//# sourceMappingURL=eqs_model_loader.js.map